
import { Component, Vue, Watch } from "vue-property-decorator";
import PackagePrintShape1 from "@/views/print/packageprint/PackagePrintShape1.vue";
import PackagePrintShape2 from "@/views/print/packageprint/PackagePrintShape2.vue";

@Component({
  name: "PackagePrint",
  components: {
    PackagePrintShape1,
    PackagePrintShape2,
  },
})
export default class extends Vue {
  //true=>原来界面，逻辑代码在C#中,vue做展示用
  //false=>新逻辑，逻辑在vue中，C#仅提供通用接口
  private useShape1: boolean = true;
  // get useShape1() {
  //   return typeof obj_Printer_Core === "undefined";
  // }
}
